module.exports = __webpack_public_path__ + "img/6.d4dd1e0c.jpg";